// eslint-disable-next-line no-shadow
export enum CITIES {
  KAZAKHSTAN = 'KAZAKHSTAN',
}
